<template>
  <div class="sitetable">
    <el-table
      :data=sites
      empty-text="No Sites Found"
      style="width: 100%">

      <el-table-column type="expand">
        <template slot-scope="props">
          <div><strong> Primary Contact </strong></div>
          <div> {{ props.row.contact.name || '' }} </div>
          <div> {{ props.row.contact.phone || '' }} </div>
          <div> {{ props.row.contact.email || '' }} </div>
          
        </template>
      </el-table-column>

      <el-table-column
         label="Name"
         prop="name"
         header-align="center">
      </el-table-column>
      <el-table-column
         label="Address"
         prop="address"
         header-align="center">
        </el-table-column>
        <el-table-column
         label="Longitude"
         prop="longitude"
         header-align="center">
        </el-table-column>
        <el-table-column
         label="Latitude"
         prop="latitude"
         header-align="center">
        </el-table-column>
        <el-table-column
         label="Zoom"
         prop="zoom"
         header-align="center"
         width="80">
      </el-table-column>
      <el-table-column
         label="Delay"
         prop="delay"
         header-align="center"
         width="90">
      </el-table-column>
      <el-table-column
         label="Standby"
         prop="standby"
         header-align="center"
         width="100">
      </el-table-column>

      <el-table-column
        v-if="userIsSuperAdmin"
        label="Operations"
        header-align="center"
        width="180">

        <template slot-scope="props">
          <operations :id="props.row.id" 
            @view="viewFields" 
            @edit="editSite(props.row)" 
            @delete="deleteSite">
          </operations>
        </template>

      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import auth from '../../../auth'
  import requests from '../../../requests';

  import operations from '../OpButtons.vue';

  export default {
    name: 'sitetable',
    props:['id', 'name'],
    data () {
      return {
        sites:[],
        userIsSuperAdmin: false,
      }
    },
    beforeMount(){
      var profile = JSON.parse(auth.getProfile());
      this.userIsSuperAdmin = (profile.role === 3);
      // this.userIsSuperAdmin = true;

      var context = this;

      requests.getSites(this, context.id, function(result){
        if(result.action === 'success'){
          var sites = result.data;
          for(var i = 0; i < sites.length; i++){
            context.sites.push(sites[i]);
          }
          console.log(sites);
        }/* else {
          context.$message({
            type: 'error',
            message: 'Failed to recieve sites for ' + context.name,
          });
        }*/
      });
    },
    methods: {
      showContact(props) {

      },
      viewFields(id) {
        this.$router.push({path:`/admin/clients/${this.id}/site/${id}`});
      },
      editSite(siteData) {
        this.$emit('editSite', siteData);
      },
      deleteSite(id) {
        this.$emit('deleteSite', id);
      },
    },
    components: {
      'operations': operations
    }
  }
  

</script>

<style>
  .el-table .cell {
    word-break: normal !important;
  }

</style>




// WEBPACK FOOTER //
// SiteTable.vue?72deeca2